// Turn a backend-relative photo url (/api/photos/…) into an absolute <img src>.
export const photoSrc = (url) => (url ? `${process.env.REACT_APP_BACKEND_URL}${url}` : undefined);

// Downscale a picked image to max 640px JPEG so uploads stay well under proxy limits.
export const compressImage = (file, maxSize = 640, quality = 0.85) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
      const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(objectUrl);
      canvas.toBlob(
        (blob) => (blob ? resolve(new File([blob], 'photo.jpg', { type: 'image/jpeg' })) : reject(new Error('Could not process image'))),
        'image/jpeg',
        quality,
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Unsupported image file'));
    };
    img.src = objectUrl;
  });
